import { SchoolCard } from '@systemeio/light-lecture-viewer'
import { useCallback } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { CourseEditApiInterface } from 'modules/courses/courses/types/course-interface'
import { LightCourseCurriculumInterface } from 'modules/courses/courses/light-course/light-course-interface'
import { useStorePreviewContext } from '../../../../../context/store-preview-context'

export const useCoursePreview = () => {
  const { setSingleItemMode, setPreview, lightLectureCss } = useStorePreviewContext()
  const { t } = useLocoTranslation()

  const showCoursePreview = useCallback(
    (
      courseData?: CourseEditApiInterface,
      courseCurriculumData?: LightCourseCurriculumInterface,
    ) => {
      setSingleItemMode(true)

      const instructorName =
        courseData?.instructorName || t('dashboard.course.instructor_name_title')
      const courseCover = courseData?.image?.path || null
      const title = courseData?.name || t('dashboard.light_course.course_title')
      const description = courseData?.description || t('dashboard.course.description_title')
      const totalLecturesCount = courseCurriculumData?.modules?.length || 0

      const customCss = `
        body, .frame-content {
          background-color: var(--color-background-primary) !important;
        }
      `

      setPreview([
        <div className={'mx-5 p-5'} key={'preview-course'}>
          <div style={{ width: '300px' }}>
            <style>{customCss + lightLectureCss}</style>
            <SchoolCard
              variant={'white'}
              description={description}
              instructorName={instructorName}
              courseCover={courseCover}
              title={title}
              progress={0}
              completedLecturesCount={0}
              totalLecturesCount={totalLecturesCount}
              accessFrom={'course'}
              href={null}
              target={null}
              userTimeFormat={null}
            />
          </div>
        </div>,
      ])
    },
    [lightLectureCss, t, setSingleItemMode, setPreview],
  )

  return { showCoursePreview }
}
